<template>
  <li :class="[cellClass, 'full-width']">
    <GoogleAdPlaceholder
      :ad-id="id"
      :page="sitePageType"
      :device="deviceType"
      :brand="pageBrand"
      :env-brand="brand"
      :is-u-s-a-region="isUSARegion"
      :is-wedding-registry="isWeddingRegistry"
    />
  </li>
</template>

<script setup>
import GoogleAdPlaceholder from '@common-vue/site-monetization/src/components/GoogleAdPlaceholder';
import { useGoogleAdId, useGoogleAdInlinePlaceholder } from '../composables';

const props = defineProps({
  googleAdOnIngridTopBanner: {
    type: Object,
    required: false,
    default: undefined,
  },
  googleAdOnIngridMidBanner: {
    type: Object,
    required: false,
    default: undefined,
  },
  googleAdOnIngridBottomBanner: {
    type: Object,
    required: false,
    default: undefined,
  },
});

const {
  classes: cellClass,
  sitePageType,
  isUSARegion,
  isWeddingRegistry,
  deviceType,
  brand,
  pageBrand,
} = useGoogleAdInlinePlaceholder();
const { id } = useGoogleAdId({ ...props });

</script>
